module.exports = __webpack_public_path__ + "static/media/3.b4608a42.png";